import { useTranslation } from "react-i18next";
import { BeaconSensorEvent } from "../../../api";
import { PagedApiState } from "../../../api/useApiState";
import { BaseDrawer } from "../../BaseDrawer";
import { AccelerometerTable } from "./AccelerometerTable";

interface BeaconAccelerometerDrawerProps {
  sensorData: PagedApiState<BeaconSensorEvent>;
  drawerVisible: boolean;
  onCloseDrawer: (visible: boolean) => void;
}

export function BeaconAccelerometerDrawer({
  sensorData,
  drawerVisible,
  onCloseDrawer,
}: BeaconAccelerometerDrawerProps) {
  const { t } = useTranslation();
  return (
    <BaseDrawer
      title={t("accelerometer")}
      drawerVisible={drawerVisible}
      onCloseDrawer={onCloseDrawer}
      dataTestId="accel-drawer"
    >
      <AccelerometerTable sensorData={sensorData} />
    </BaseDrawer>
  );
}
